module.exports = __webpack_public_path__ + "assets/8c4c45db01516f90242e6c7230a3bed1.svg";